import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import SideBarMenuDropdown from './SideBarMenuDropdown';
import SideBarMenuListing from "./SideBarMenuListing";
import SideBarMenuGrid from "./SideBarMenuGrid";

const SidebarMenu = (props) => {

    const navigate = useNavigate();
    // const token = React.useMemo(() => window.localStorage.getItem("user_token"), []);
    // React.useMemo is retrive only once that why I used below code
    const token = window.localStorage.getItem("user_token");

    const { componentSetting, playerMenu } = useSelector((state) => ({
        userProfile: state.playerProfileR?.data ?? {},
        playerMenu: state.menuListR.data,
        componentSetting: state.componentSettingListR.data,
    }));

    const [openMenu, setOpenMenu] = useState([]);
    const [loggedIn, setLoggedIn] = useState('');
    const [menuList, setMenuList] = useState([]);

    const pushMenu = (menuName) => {
        const selectedMenu = [...openMenu];
        const index = selectedMenu.indexOf(menuName);

        if (index === -1) {
            selectedMenu.push(menuName);
        } else {
            selectedMenu.splice(index, 1);
        }
        setOpenMenu(selectedMenu);
    }


    useEffect(() => {
        if (playerMenu) {
            let menuListToSet;

            const languageObject = {
                "name": "Language",
                "code": "language",
                "location": "menu",
                "status": true,
                "order": 9999,
            };

            if (!loggedIn) {
                menuListToSet = playerMenu['before'];
            } else {
                menuListToSet = playerMenu['after'];
            }

            menuListToSet['language'] = languageObject;

            const menuArray = Object.values(menuListToSet);
            menuArray.sort((a, b) => parseInt(a.order) - parseInt(b.order));

            const sortedMenuObject = menuArray.reduce((acc, item) => {
                acc[item.code] = item;
                return acc;
            }, {});

            setMenuList(sortedMenuObject);
        }
    }, [loggedIn, playerMenu]);

    useEffect(() => {
        setLoggedIn(token);
    }, [token]);

    return (
        <div className={`menu-links-mobile ${componentSetting?.["mobile_sidebar_menu_listing"]?.["default-value"] === "menu_listing" ? 'active-sidebar-menu' : ''}`}>
            <div className="item">
                {/* {Object.values(menuList).map((v, i) => {
                    let customLink = '';

                    if (v.code === 'home') {
                        customLink = '';
                    } else if (v.code === 'my-referral') {
                        customLink = 'referral';
                    } else {
                        customLink = v?.code;
                    }

                    return (
                        <React.Fragment key={v.code}>
                            {
                                (componentSetting?.["mobile_sidebar_menu_listing"]?.["default-value"] ==
                                    "dropdown_listing") && (
                                    <SideBarMenuDropdown
                                        menuList={menuList}
                                        v={v}
                                        i={i}
                                        openMenu={openMenu}
                                        playerMenu={playerMenu}
                                        handleClose={props?.handleClose}
                                        pushMenu={pushMenu}
                                        loggedIn={loggedIn}
                                        customLink={customLink}
                                        desktop={props.desktop}
                                    />
                                )
                            }

                            {
                                (componentSetting?.["mobile_sidebar_menu_listing"]?.["default-value"] ==
                                    "menu_listing") && (
                                    <SideBarMenuListing
                                        menuList={menuList}
                                        v={v}
                                        i={i}
                                        openMenu={openMenu}
                                        playerMenu={playerMenu}
                                        handleClose={props?.handleClose}
                                        pushMenu={pushMenu}
                                        loggedIn={loggedIn}
                                        customLink={customLink}
                                        desktop={props.desktop}
                                    />
                                )
                            }


                        </React.Fragment>
                    )
                })} */}

                {
                    <SideBarMenuGrid
                        menuList={menuList}
                        openMenu={openMenu}
                        playerMenu={playerMenu}
                        loggedIn={loggedIn}
                        handleClose={props?.handleClose}
                    />
                }

            </div>
        </div>
    )
}

SidebarMenu.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(SidebarMenu);